/**
 * Recursively checks if an object or any nested object contains the boolean value `true`.
 * Only matches the literal boolean `true`, not other truthy values.
 *
 * @param {*} value - The value to check (object, array, primitive, etc.)
 * @returns {boolean} - Returns true if the boolean `true` is found anywhere in the structure, false otherwise
 */
const hasTrue = (value) => {
  // Base case: if the value is exactly the boolean true, return true
  if (value === true) {
    return true
  }

  // If value is null, undefined, or not an object/array, return false
  if (value === null || value === undefined || typeof value !== 'object') {
    return false
  }

  // Handle arrays - iterate through each element
  if (Array.isArray(value)) {
    return value.some((item) => hasTrue(item))
  }

  // Handle objects - iterate through each property value
  return Object.values(value).some((val) => hasTrue(val))
}

export default hasTrue
